import $http from '@/api/index'
import axios from 'axios'
import qs from 'qs'

//获取通知通告
export function GetNoticeInfoBySearch(title, currentuserid, noticeobject, startnoticetime, endnoticetime,searchType, ispower) {
	let getUrl = {
		method: 'GET',
		url: 'NMS/GetNoticeInfoBySearch',
		requestType: 2
	}
	let params = {
		title: title,
		currentuserid: currentuserid,
		noticeobject: noticeobject,
		startnoticetime: startnoticetime,
		endnoticetime: endnoticetime,
		searchtype:searchType,
		ispower: ispower,
	}
	return $http(getUrl, params)
}
//获取通知通告(新)
export function GetNoticePlanInfoBySearchWeb(searchpara) {
	let getUrl = {
		method: 'GET',
		url: 'NMS/GetNoticePlanInfoBySearchWeb',
		requestType: 2
	}
	let params = {
		searchpara: searchpara
	}
	return $http(getUrl, params)
}
//获取通知通告计划
export function GetNoticePlanInfoBySearch(title, currentuserid, noticeobject, startnoticetime, endnoticetime,searchType, ispower) {
	let getUrl = {
		method: 'GET',
		url: 'NMS/GetNoticePlanInfoBySearch',
		requestType: 2
	}
	let params = {
		title: title,
		currentuserid: currentuserid,
		noticeobject: noticeobject,
		startnoticetime: startnoticetime,
		endnoticetime: endnoticetime,
		searchtype:searchType,
		ispower: ispower,
	}
	return $http(getUrl, params)
}
//GetPolicyInstanceByClassifyId获取通知策略
export function GetPolicyInstanceByClassifyId(classifyId,isConsultation) {
	let getUrl = {
		method: 'GET',
		url: 'NMS/GetPolicyInstanceByClassifyId',
		requestType: 2
	}
	let params = {
		classifyId: classifyId,
		isconsultation:isConsultation
	}
	return $http(getUrl, params)
}
//通知id获取通知详情GetHostListByMaclist
//export function GetNoticeWebAllInfoByNoticeId(id) {
//	let getUrl = {
//		method: 'GET',
//		url: 'NMS/GetNoticeWebAllInfoByNoticeId',
//		requestType: 2
//	}
//	let params = {
//		noticeid: id,
//	}
//	return $http(getUrl, params)
//}
//macLIST获取计算机列表
export function GetHostListByMaclist(list) {
	let getUrl = {
		method: 'GET',
		url: 'basedata/GetHostListByMaclist',
		requestType: 2
	}
	let params = {
		macinfolist: list,
	}
	return $http(getUrl, params)
}
//GetPolicyInstanceByClassifyId获取通知人员
export function GetAllUserTreeListForPolicy(id, type) {
	let getUrl = {
		method: 'GET',
		url: 'NMS/GetAllUserTreeListForPolicy',
		requestType: 2
	}
	let params = {
		userId: id,
		type: type
	}
	return $http(getUrl, params)
}
//提交通知
export function AddNoticeInfo(formData) {
	let options = {
		method: 'post',
		url: 'NMS/AddNoticeInfo',
		requestType: 2,
		isFormData: true
	}
	return $http(options, formData)
}
//回复通知
export function replyNotice(sendId,replycontent) {
	let options = {
		method: 'post',
		url: 'NMS/UpdateWeChatNoticeMessageReturnInfoBySendId?sendId='+sendId+'&replycontent='+replycontent,
		requestType: 2
	}
	let params = {
	}
	return $http(options, params)
}
//提交通知计划
export function AddNoticePlanByWeb(formData) {
	let options = {
		method: 'post',
		url: 'NMS/AddNoticePlanByWeb',
		requestType: 2,
		isFormData: true
	}
	return $http(options, formData)
}
//审核通知计划AuditNoticePlan
export function AuditNoticePlan(formData) {
	let options = {
		method: 'post',
		url: 'NMS/AuditNoticePlan',
		requestType: 2,
		isFormData: true
	}
	return $http(options, formData)
}
///获取楼栋下的层
export function GetPubStoryByBuildingId(buildingId) {
	let getUrl = {
		method: 'GET',
		url: 'user/GetPubStoryByBuildingId',
		requestType: 2
	}
	let params = {
		buildingId
	}
	return $http(getUrl, params)
}
///获取层下的房间
export function GetStoryRoom(storyid) {
	let getUrl = {
		method: 'GET',
		url: 'user/GetStoryRoom',
		requestType: 2
	}
	let params = {
		storyid
	}
	return $http(getUrl, params)
}

//提交通知计划详情
export function AddNoticeDetailInfoByWeb(formData) {
	let options = {
		method: 'post',
		url: 'NMS/AddNoticeDetailInfoByWeb',
		requestType: 2,
		isFormData: true
	}
	return $http(options, formData)
}
//通过计划ID获取对应的汇总通知记录
export function GetNoticeGatherInfoByPlanid(planid) {
	let getUrl = {
		method: 'GET',
		url: 'NMS/GetNoticeGatherInfoByPlanid',
		requestType: 2
	}
	let params = {
		planid: planid
	}
	return $http(getUrl, params)
}
//根据通知id获取对应的通知对象
export function GetNoticeInstanceUserListByNoticeid(noticeid) {
	let getUrl = {
		method: 'GET',
		url: 'NMS/GetNoticeInstanceUserListByNoticeid',
		requestType: 2
	}
	let params = {
		noticeid: noticeid
	}
	return $http(getUrl, params)
}
//获取分组信息
export function GetNoticeWebAllInfoByNoticeId(noticeid) {
	let getUrl = {
		method: 'GET',
		url: 'NMS/GetNoticeWebAllInfoByNoticeId',
		requestType: 2
	}
	let params = {
		noticeid: noticeid
	}
	return $http(getUrl, params)
}
//点击执行
export function ExcuteNoticeMaster(masterid) {
	let getUrl = {
		method: 'POST',
		url: 'NMS/ExcuteNoticeMaster?masterid='+masterid,
		requestType: 2
	}
	let params = {
		//masterid: masterid
	}
	return $http(getUrl, params)
}
//查询通知详情UpdateFixedTime
export function GetNoticeResultByRelationId(relationId, relationType) {
	let getUrl = {
		method: 'GET',
		url: 'NMS/GetNoticeResultByRelationId',
		requestType: 2
	}
	let params = {
		relationId: relationId,
		relationType: relationType
	}
	return $http(getUrl, params)
}
//获取定时
export function GetNoticeMasterInfoByMasterid(masterid) {
	let getUrl = {
		method: 'GET',
		url: 'NMS/GetNoticeMasterInfoByMasterid',
		requestType: 2
	}
	let params = {
		masterid: masterid
	}
	return $http(getUrl, params)
}
//修改定时时间
export function UpdateFixedTime(masterid, dtfixedtime) {
	let getUrl = {
		method: 'POST',
		url: 'NMS/UpdateFixedTime?masterid='+masterid+'&dtfixedtime='+dtfixedtime,
		requestType: 2
	}
	let params = {
//		masterid: masterid,
//		dtfixedtime: dtfixedtime
	}
	return $http(getUrl, params)
}
//
export function GetNoticeStyleList() {
	let getUrl = {
		method: 'GET',
		url: 'NMS/GetNoticeStyleList',
		requestType: 2
	}
	let params = {
	}
	return $http(getUrl, params)
}
//删除通知详情
export function DeleteNoticeInfo(Id) {
	let getUrl = {
		method: 'POST',
		url: 'NMS/DeleteNoticeInfo' + '?Id=' + Id,
		requestType: 2
	}
	let params = {
		//	Id:Id
	}
	return $http(getUrl, params)
}
//获取通知登陆人
export function GetSysUserByCode(code) {
	let getUrl = {
		method: 'GET',
		url: 'user/GetSysUserByCode',
		requestType: 2
	}
	let params = {
		Code: code
	}
	return $http(getUrl, params)
}
// 获取所有通知实例分类集合
export function GetNoticeInstanceClassify() {
	let getUrl = {
		method: 'GET',
		url: 'NMS/GetNoticeInstanceClassify',
		requestType: 2
	}
	let params = {}
	return $http(getUrl, params)
}
/*
 * 客户机精确查找部分
 */
/*
 * GetEnableGroupInformation
 * 获取分组
 */
export function GetEnableGroupInformation() {
	let getUrl = {
		method: 'GET',
		url: 'TMS/GetEnableGroupInformation',
		requestType: 2
	}
	let params = {}
	return $http(getUrl, params)
}
/*
 * GetAllEnabledCompany
 * 获取在用的区域
 */
export function GetAllEnabledCompany() {
	let getUrl = {
		method: 'GET',
		url: 'basedata/GetAllEnabledCompany',
		requestType: 2
	}
	let params = {}
	return $http(getUrl, params)
}
/*
 * GetBuildingByPId
 *根据区域Id获取对应下的楼层信息
 * Id：区域ID
 */
export function GetBuildingByPId(Id) {
	let getUrl = {
		method: 'GET',
		url: 'basedata/GetBuildingByPId',
		requestType: 2
	}
	let params = {
		pid: Id
	}
	return $http(getUrl, params)
}
/*
 * GetHostOstypeList
 *获取所有操作系统
 */
export function GetHostOstypeList() {
	let getUrl = {
		method: 'GET',
		url: 'basedata/GetHostOstypeList',
		requestType: 2
	}
	let params = {}
	return $http(getUrl, params)
}
/*
 * GetSearchPubHostListbyParam
 *获取客户机信息
 */
export function GetSearchPubHostListbyParam(form) {
	let getUrl = {
		method: 'GET',
		url: 'basedata/GetSearchPubHostListbyParam',
		requestType: 2
	};
	let param = JSON.stringify({
		HostIp: form.HostIp,
		HostMac: form.HostMac,
		ComputerCode: form.ComputerCode,
		GroupId: form.GroupId,
		GroupName: form.GroupName,
		DeptId: form.DeptId,
		DeptName: form.DeptName,
		OnlineState: form.OnlineState,
		DistrictId: form.DistrictId,
		DistrictName: form.DistrictName,
		Building: form.Building,
		InstallType: form.InstallType, //安装类型
		UpdateMode: form.UpdateMode,
		OpstateType: form.OpstateType,
		OpstateTypeName: form.OpstateTypeName
	});
	const params={
		param:param
	}
	return $http(getUrl, params)
}
/*
 * GetNoticeHostResultByRelationId
 *获取客户机通知详情
 */
export function GetNoticeHostResultByRelationId(ID) {
	let getUrl = {
		method: 'GET',
		url: 'NMS/GetNoticeHostResultByRelationId',
		requestType: 2
	}
	let params = {
		relationId:ID
	}
	return $http(getUrl, params)
}
//添加常用联系人
export function AddCommonUserWeb(formData) {
	let options = {
		method: 'post',
		url: 'NMS/AddCommonUserWeb',
		requestType: 2,
		isFormData: true
	}
	return $http(options, formData)
}
//查询常用联系人
export function GetCommonUserListWeb() {
	let getUrl = {
		method: 'GET',
		url: 'NMS/GetCommonUserListWeb',
		requestType: 2
	}
	let params = {
	}
	return $http(getUrl, params)
}
//查询常用联系人
export function JudgeExistPhoneNumber(phonenumber) {
	let getUrl = {
		method: 'GET',
		url: 'NMS/JudgeExistPhoneNumber',
		requestType: 2
	}
	let params = {
		phonenumber:phonenumber
	}
	return $http(getUrl, params)
}
//删除联系人
export function DeleteCommonUserByIdWeb(Id) {
	let getUrl = {
		method: 'POST',
		url: 'NMS/DeleteCommonUserByIdWeb' + '?Id=' + Id,
		requestType: 2
	}
	let params = {
		//	Id:Id
	}
	return $http(getUrl, params)
}
//更新常用联系人
export function UpdateCommonUserWeb(formData) {
	let options = {
		method: 'post',
		url: 'NMS/UpdateCommonUserWeb',
		requestType: 2,
		isFormData: true
	}
	return $http(options, formData)
}
export function GetWebDoorProgramList() {
	let getUrl = {
		method: 'GET',
		url: 'TMS/GetWebDoorProgramList',
		requestType: 2
	}
	let params = {
	}
	return $http(getUrl, params)
}
//  获取所有在用的通知方法

export function GetAllNoticeMethodList() {
	let getUrl = {
		method: 'GET',
		url: 'NMS/GetAllNoticeMethodList',
		requestType: 2
	}
	let params = {
	}
	return $http(getUrl, params)
}

// 根据通知实例ID获取整个通知策略详情
export function GetNoticeMethodAggrByInstanceId(id) {
	let getUrl = {
		method: 'GET',
		url: 'NMS/GetNoticeMethodAggrByInstanceId?instanceid='+id,
		requestType: 2
	}
	let params = {
	}
	return $http(getUrl, params)
}
// 传空取所有 其他传值则显示对于的值
export function GetAllNoticeMethodAggrList(policytype) {
	let getUrl = {
		method: 'GET',
		url: 'NMS/GetAllNoticeMethodAggrList?policytype='+policytype,
		requestType: 2
	}
	let params = {
	}
	return $http(getUrl, params)
}

// 新增或者修改通知策略
export function AddOrUpdateNoticePolicyInstance(params) {
	let getUrl = {
		method: 'POST',
		url: 'NMS/AddOrUpdateNoticePolicyInstance',
		requestType: 2
	}
	
	return $http(getUrl, params)
}
//根据通知实例ID 删除对应的通知实例 逻辑删除
export function DeleteNoticePolicyInstanceById(id) {
	let getUrl = {
		method: 'POST',
		url: 'NMS/DeleteNoticePolicyInstanceById?Id='+id,
		requestType: 2
	}
	let params = {
	}
	return $http(getUrl, params)
}

//根据通知实例ID 删除对应的通知实例 逻辑删除
export function GetNoticeResultMasterListBySearchPama(pageindex,pagesize,searchparam) {
	let getUrl = {
		method: 'GET',
		url: 'NMS/GetNoticeResultMasterListBySearchPama?pageindex='+pageindex+'&pagesize='+pagesize+'&searchparam='+searchparam,
		requestType: 2
	}
	let params = {
	}
	return $http(getUrl, params)
}

/**
 * @description 获取我的群组 参数userId
 * @constructor
 */
export function GetGroup(userId) {
	let getUrl = {
		method: 'GET',
		url: 'Group',
		requestType: 9
	}
	let params = {
		userId:userId
	}
	return $http(getUrl, params)
}
/**
 * @description 获取群人员 GetGroupMember
 * @constructor
 */
export function GetGroupMember(groupId){
	let getUrl = {
		method: 'GET',
		url: 'group/Member',
		requestType: 9
	}
	let params = {
		groupId: groupId
	}
	return $http(getUrl, params)
}

// 新增通知计划-通知策略取值列表
export function GetNoticePolicyInstanceListByType(policytype) {
	let getUrl = {
		method: 'GET',
		url: 'NMS/GetNoticePolicyInstanceListByType?policytype='+policytype,
		requestType: 2
	}
	let params = {
	}
	return $http(getUrl, params)
}
//新增新建通知计划
export function AddNoticeManualByWeb(params) {
	let getUrl = {
		method: 'POST',
		url: 'NMS/AddNoticeManualByWeb',
		requestType: 2,
		isFormData: true
	}
	return $http(getUrl, params)
}
// 搜索查询人工通知列表
export function GetNoticeManualListBySearchParaWeb(params) {
	let getUrl = {
		method: 'GET',
		url: 'NMS/GetNoticeManualListBySearchParaWeb',
		requestType: 2,
	}
	return $http(getUrl, params)
}
// 根据id搜索查询人工通知详情
export function GetNoticeResultDetailListByRelationId(relationId,relationType) {
	let getUrl = {
		method: 'GET',
		url: 'NMS/GetNoticeResultDetailListByRelationId?relationId='+relationId+'&relationType='+relationType,
		requestType: 2,
	}
	let params={};
	return $http(getUrl, params)
}

// 通过人工通知ID获取对应的通知策略及通知人员
export function GetNoticeManualDetailById(id) {
	let getUrl = {
		method: 'GET',
		url: 'NMS/GetNoticeManualDetailById?id='+id,
		requestType: 2,
	}
	let params={};
	return $http(getUrl, params)
}
// 客户端通知详情
export function GetNoticeManualAllInfoByNoticeId(noticeId) {
	let getUrl = {
		method: 'GET',
		url: 'NMS/GetNoticeManualAllInfoByNoticeId?noticeId='+noticeId,
		requestType: 2,
	}
	let params={};
	return $http(getUrl, params)
}
// 获取通知详情里的文件
export function GetNoticeManualAttachFileByNoticeId(noticeId) {
	let getUrl = {
		method: 'GET',
		url: 'NMS/GetNoticeManualAttachFileByNoticeId?noticeId='+noticeId,
		requestType: 2,
	}
	let params={};
	return $http(getUrl, params)
}

// 根据业务id和业务类型及关联id 获取对应的通知结果
export function GetNoticeResultDetailListByPolicyRelationId(relationId,relationType,policyrelationId) {
	let getUrl = {
		method: 'GET',
		url: 'NMS/GetNoticeResultDetailListByPolicyRelationId?relationId='+relationId+'&relationType='+relationType+'&policyrelationId='+policyrelationId,
		requestType: 2,
	}
	let params={};
	return $http(getUrl, params)
}






